import { render, staticRenderFns } from "./AccountsAndCashboxes.vue?vue&type=template&id=95c1cb40&scoped=true"
import script from "./AccountsAndCashboxes.vue?vue&type=script&lang=ts"
export * from "./AccountsAndCashboxes.vue?vue&type=script&lang=ts"
import style0 from "./AccountsAndCashboxes.vue?vue&type=style&index=0&id=95c1cb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c1cb40",
  null
  
)

export default component.exports